<!-- 
CustomerPrint.vue
功能：列印地址名條
作者：i9400538 陳博承
完成：2020-09-07
-->
<template>
  <main class="scroll-lock" style="height:520px" :class="{'section-loading': isloading}">
    <section class="container-fluid">
      <h4>本次選擇{{printType}}格式</h4>
      <div class="title-div">
        <span class="text-green title-text">列印客戶：{{selection.length}}位</span>
      </div>
    </section>
    <div class="container-fluid">
      <div class="row row-tables newTable">
        <table
          class="table datatable table-striped area-list-datatable"
          id="CustomerPrintDataTable"
        >
          <thead>
            <tr>
              <th width="120">
                <div class="checkbox checkbox-inline mr-0">
                  <input
                    @click="clickTarget = clickTarget == `clickAll`? `clickAll-again`: `clickAll`"
                    type="checkbox"
                    name="check-all"
                    id="check-all"
                    value="1"
                    v-model="checkAll"
                  />
                  <label for="check-all"></label>
                </div>
                <span>#</span>
              </th>
              <th width="120">姓名</th>
              <th width="120">手機</th>
              <th width="120">電話</th>
              <th width="*">現居地址</th>
              <th width="*" ref="lastCol">公司地址</th>
            </tr>
          </thead>
          <tbody :style="{height: scrollHeight + 'px'}">
            <tr v-for="(d, did) in tableData" :key="`CustomerPrintDataTable-table-td-${did}`">
              <td width="120">
                <div style="min-height: 30px;">
                  <div class="mr-0 checkbox checkbox-inline">
                    <input
                      @click="clickTarget = clickTarget == `td-${did}`? `td-${did}-again`: `td-${did}`"
                      type="checkbox"
                      :name="`td-check-item-${did}`"
                      :id="`CustomerPrintDataTable-check-${did}`"
                      :value="d.id"
                      v-model="selection"
                      :disabled="d.id ===''"
                      @change="updateSelection(selection)"
                    />
                    <label :for="`CustomerPrintDataTable-check-${did}`"></label>
                  </div>
                  <span>
                    <span class="no">{{did + 1}}</span>
                    <span class="info text-center">
                      <level :lv="Number(d.vip_lvl)" />
                      <avatar :gender="Number(d.sex)" :size="20" />
                    </span>
                  </span>
                </div>
              </td>
              <td width="120">
                <Tooltip
                  :position="did < 3?'bottom':'top'"
                  :name="d.name"
                  :address="d.address"
                  :mobile="d.mobile"
                  :phone="d.phone"
                  :company_address="d.company_address"
                >
                  <span>{{d.name | emptyField | getMaskName}}</span>
                </Tooltip>
              </td>
              <td width="120">{{d.mobile | emptyField | getMaskMobile}}</td>
              <td width="120">{{d.phone | emptyField | getMaskPhone}}</td>
              <td width="*">
                <div class="radio radio-inline">
                  <input
                    type="radio"
                    :name="`select-address-${did + 1}`"
                    :value="`${d.id}`"
                    :id="`${d.id}`"
                    @change="addAddress(d,'address')"
                    :checked="d.isDefault==='Y'"
                  />
                  <label :for="`${d.id}`">{{d.address | emptyField | getMaskAddress}}</label>
                </div>
              </td>
              <td :width="iPadWidth">
                <div class="radio radio-inline">
                  <input
                    type="radio"
                    :name="`select-address-${did + 1}`"
                    :value="`${d.id}`"
                    :id="`comp-${d.id}`"
                    @change="addAddress(d,'company_address')"
                    :checked="d.isDefault==='N'"
                  />
                  <label :for="`comp-${d.id}`">{{d.company_address | emptyField | getMaskAddress}}</label>
                </div>
              </td>
            </tr>
            <tr v-if="tableData.length == 0">
              <td colspan="6" class="text-center pt-3 pb-5">
                <h3>無客戶名單資料</h3>
              </td>
              <td style="display: none;"></td>
              <td style="display: none;"></td>
              <td style="display: none;"></td>
              <td style="display: none;"></td>
              <td style="display: none;"></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <section class="container-fluid">
      <div class="row">
        <div v-show="printTypeEn ==='post'">
          <ul class="print-note">
            <li>列印名條貼紙格式參考：鶴屋-C37105-A4三用電腦標籤 (37.1x105mm)</li>
          </ul>
        </div>
        <div style="margin-left:auto; margin-right:0;margin-top: 5px;" v-if="printTypeEn ==='post'">
          <button type="button" class="btn btn-primary" @click="cancel">取消</button>
          <button
            type="button"
            class="btn btn-primary mr-0"
            @click="doPrint('new')"
            :disabled="!selection.length"
          >列印</button>
          <!--<button
            type="button"
            class="btn btn-primary mr-0"
            @click="doPrint('old')"
            :disabled="!selection.length"
          >列印舊版 (開放至4/10)</button>-->
        </div>
        <div style="margin-left:auto; margin-right:0;" v-if="printTypeEn ==='phone'">
          <button type="button" class="btn btn-primary" @click="cancel">取消</button>
          <button
            type="button"
            class="btn btn-primary mr-0"
            @click="doPrint('new')"
            :disabled="!selection.length"
          >列印</button>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
import {mapGetters} from 'vuex'
import { mapActions } from "vuex";
import { commonMixin } from "@/mixins/common";
//component
import Level from "@/components/Level";
import Avatar from "@/components/Avatar";
import Tooltip from "@/desktop/components/ToolTip";
//service
import {
  getPostalPDF,
  getPhonePDF,
  savePrintAddress,
  getCustDataForSavePrint
} from "@/service";
const is_iPad = navigator.userAgent.match(/iPad/i) != null; // 確認裝置是否為 iPad

export default {
  name: "CustomerPrint",
  mixins: [commonMixin],
  components: { Level, Avatar, Tooltip },
  props: {
    status: String
  },
  data() {
    return {
      checkAll: true,
      clickTarget: "",
      tableData: [],
      selection: [],
      selectAddress: [],
      selectCompanyAddress: [],
      printType: "",
      printTypeEn: "",
      isloading: false,
      scrollHeight: 0,
      is_iPad: is_iPad,
      iPadWidth: 364
    };
  },
  computed : {
    ...mapGetters([ 'UserInfo' ]),
    isBox() {
     //判斷是否為box
     return this.UserInfo.userType === 'box'
    }
  },
  watch: {
    checkAll: "toggleCheckAll",
    clickTarget: function(target) {
      if (target == "clickAll" || target == "clickAll-again") {
        //點了全選checkbox
        if (this.checkAll) {
          //點了全選
          this.selection = [];
          this.tableData.forEach(data => {
            this.selection.push(data.id);
          });
        }
      } else {
        //點了其他checkbox
        this.checkAll = this.selection.length == this.tableData.length;
      }
    }
  },
  methods: {
    ...mapActions(["setPageLock", "updateCustID"]),
    toggleCheckAll(val) {
      if (val) {
        //全選時，勾選筆數 = 全部筆數
        this.selection = this.tableData.map(item => {
          return item.id;
        });
      } else {
        if (this.selection.length === this.tableData.length) {
          //取消全選時，若當前勾選筆數 = 全部筆數，才需要整個清空
          this.selection = [];
        }
      }
    },
    updateSelection(val) {
      this.selection = val;
    },
    init() {
      // 資料初始化
      this.printType = this.$route.params.printType || ""; //列印格式
      this.printTypeEn = this.$route.params.printTypeEn || ""; //列印格式(英文)
      let queryCust = this.$route.params.queryCust || []; //要查詢的客戶ID
      if (this.printType && queryCust.length > 0) {
        this.isloading = true; //開啟遮罩
        getCustDataForSavePrint(this.$store.state.userInfo.id, queryCust).then(
          result => {
            this.isloading = false;
            if (result.header && result.header.status == "200") {
              this.tableData = result.body.result.map(item => {
                item.isDefault = !item.print_type ? "Y" : "N";
                return item;
              });
              this.toggleCheckAll(true); //預設全選
              this.registerHanlink(); // for hard word
            } else {
              //  API Error
              this.setToastMsg(result.header.message);
            }
          }
        );
      }
    },
    doPrint(type) {
      //列印
      //過濾掉不允許列印的資料
      let printList = this.selection;
      if (printList.length === 0) {
        //沒有需要列印的資料
        this.setToastMsg("勾選客戶無法列印");
        return;
      }
      //過濾掉有異動現居地址，但沒有要列印的資料
      let filterAddressList = this.selectAddress.filter(item => {
        let findIndex = printList.indexOf(item);
        if (findIndex !== -1) {
          return item;
        }
      });
      //過濾掉有異動公司地址，但沒有要列印的資料
      let filterCompanyAddressList = this.selectCompanyAddress.filter(item => {
        let findIndex = printList.indexOf(item);
        if (findIndex !== -1) {
          return item;
        }
      });
      let isAddress = filterAddressList.length !== 0 ? "Y" : "N";
      let isCompanyAddress = filterCompanyAddressList.length !== 0 ? "Y" : "N";
      this.isloading = true; //開啟遮罩
      if (
        isAddress === "Y" ||
        isCompanyAddress === "Y"
      ) {
        //有異動預設列印地址才去呼叫儲存列印地址API
        savePrintAddress(
          this.$store.state.userInfo.id,
          filterAddressList,
          filterCompanyAddressList,
          isAddress,
          isCompanyAddress
        ).then(result => {
          if (result.header && result.header.status == "200") {
            //清空預設資料
            this.selectAddress = [];
            this.selectCompanyAddress = [];
            //呼叫產生PDF方法
            this.createPDF(printList, type);
          } else {
            // API Error
            this.setToastMsg(result.header.message);
          }
        });
      } else {
        //無異動預設列印地址，直接呼叫產生PDF方法
        this.createPDF(printList, type);
      }
    },
    createPDF(printList, type) {
      let newWindow;
      if (!this.isBox) {
        newWindow = window.open("/crm/assets/common/ajax-loader.gif")
      }
      if (this.printType === "郵政局") {
        // 郵政局格式
        getPostalPDF(
          this.$store.state.userInfo.id,
          printList,
          "false",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "1",
          "99999",
          type
        ).then(result => {
          this.isloading = false; //關閉遮罩
          if (this.isBox) {
            this.boxSendBase64PdfData(result);
          } else {
            let file = new Blob([result], { type: "application/pdf" });
            if (window.navigator.msSaveOrOpenBlob) {
              window.navigator.msSaveOrOpenBlob(file, "post.pdf");
            } else {
              newWindow.location = URL.createObjectURL(file);
            }
          }
        });
      } else if (this.printType === "電話簿") {
        // 電話簿
        getPhonePDF(
          this.$store.state.userInfo.id,
          printList,
          "false",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "1",
          "99999"
        ).then(result => {
          this.isloading = false; //關閉遮罩
          if (this.isBox) {
            this.boxSendBase64PdfData(result);
          } else {
            let file = new Blob([result], { type: "application/pdf" });
            if (window.navigator.msSaveOrOpenBlob) {
              window.navigator.msSaveOrOpenBlob(file, "phone.pdf");
            } else {
              newWindow.location = URL.createObjectURL(file);
            }
          }
        });
      }
    },
    cancel() {
      //取消
      this.$router.go(-1);
    },
    addAddress(item, type) {
      let id = item.id;
      let findIndex = this.selectAddress.indexOf(id);
      let findIndexComp = this.selectCompanyAddress.indexOf(id);
      if (type === "address") {
        //點選現居地址
        if (findIndex === -1) {
          this.selectAddress.push(id);
        }
        if (findIndexComp !== -1) {
          this.selectCompanyAddress.splice(findIndexComp, 1); //移除公司地址
        }
        item.isDefault = "Y";
      } else {
        //點選公司地址
        if (findIndexComp === -1) {
          this.selectCompanyAddress.push(id);
        }
        if (findIndex !== -1) {
          this.selectAddress.splice(findIndex, 1); //移除現居地址
        }
        item.isDefault = "N";
      }
    }
  },
  mounted() {
    if (!is_iPad && this.UserInfo.userType !== 'box') {
      this.iPadWidth = this.$refs.lastCol.clientWidth - 15;
    } else {
      this.iPadWidth = this.$refs.lastCol.clientWidth;
    }

    // 資料初始化
    this.scrollHeight = $(window).height() - 315;
    this.init();

    let self = this;
    $(window).bind("resize", function() {
      self.scrollHeight = $(window).height() - 315;
      self.iPadWidth = self.$refs.lastCol.clientWidth;
    });
  }
};
</script>

<style lang="scss" scoped>
.newTable thead tr,
.newTable tbody tr {
  display: table;
  width: 100%;
  table-layout: fixed;
}

.newTable tbody {
  display: block;
  height: auto;
  overflow-y: scroll;
  border: 0 !important;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    width: 17px;
    border: 0;
    box-shadow: none;
  }

  &::-webkit-scrollbar-track {
    box-shadow: none;
    border-radius: 0px;
    border: 0;
    background-color: #f5f5f5;
  }

  &::-webkit-scrollbar-thumb {
    width: 10px;
    border-radius: 20px;
    background-color: #555;
  }
}

.row.row-tables {
  width: 100%;
  margin-left: 0;
  margin-right: 0;
  display: table;
  > * {
    position: relative;
    display: table-cell;
  }
  .col-table {
    width: 100% !important;
  }
  .icon-forward {
    visibility: hidden;
  }
}
.title-div {
  padding-top: 1.5rem;
  padding-bottom: 0.5rem;
}
.title-text {
  font-weight: 600;
  font-size: 20px;
  margin-bottom: 0.5rem;
  font-family: inherit;
  line-height: 1.2;
  margin-block-start: 1.33em;
  margin-block-end: 1.33em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
}
.print-note{
  list-style-type: none; 
  color:#DE4054;
  font-size: medium;
  font-weight: 600;
}
</style>